import { render, staticRenderFns } from "./SupportingDocumentForm.vue?vue&type=template&id=2ecebc97&scoped=true&"
import script from "./SupportingDocumentForm.vue?vue&type=script&lang=js&"
export * from "./SupportingDocumentForm.vue?vue&type=script&lang=js&"
import style0 from "./SupportingDocumentForm.vue?vue&type=style&index=0&id=2ecebc97&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ecebc97",
  null
  
)

export default component.exports